import * as v from 'valibot';

import { ENOPOrganType, EResourceStatus } from '#shared';

import type { CCSurgeon } from '../types';

export const surgeonSchema: v.GenericSchema<CCSurgeon> = v.object({
  id: v.string('Surgeon ID is missing'),
  hubId: v.nullable(v.string('Hub ID is missing')),
  regionId: v.nullable(v.string('Region ID is missing')),
  organs: v.nullable(
    v.array(
      v.enum(
        ENOPOrganType,
        issue => `@WARNING: Unexpected organ type ${issue.input}`,
      ),
      'Organs are missing',
    ),
  ),
  status: v.enum(
    EResourceStatus,
    issue => `@WARNING: Unexpected status ${issue.input}`,
  ),
  timezone: v.nullable(v.string('Timezone is missing')),
});
